import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { Carousel } from "antd";
import { ReactComponent as NextIcon } from "icons/sliderNextIcon.svg";
import { ReactComponent as PreviousIcon } from "icons/sliderPreviousIcon.svg";
import { getVideoRatioDynamic } from "components/visualize-wrapper -multi/helpers";

export const ImagesCarousel = ({
  videoHeight,
  videoWidth,
  imageData,
  imageIndex,
  positions,
}) => {
  console.log({ imageData });

  const sliderRef = useRef();
  const visualizeSmallContainerRef = useRef(null);
  const [containerSmallWidthDynamic, setContainerSmallWidthDynamic] =
    useState(null);

  const contentStyle = {
    margin: 0,
    height: "95dvh",
    color: "#fff",
    padding: "0 10px",
    position: "relative",
  };

  useEffect(() => {
    sliderRef.current.goTo(imageIndex);
  }, [imageIndex]);

  useEffect(() => {
    setTimeout(() => {
      if (!visualizeSmallContainerRef.current) return;

      const containerHeight = visualizeSmallContainerRef.current.clientHeight;

      const ratioWidth = getVideoRatioDynamic({
        height: containerHeight,
        videoHeight,
        videoWidth,
      });

      setContainerSmallWidthDynamic(ratioWidth);
    }, 1);
  }, [videoHeight, videoWidth]);
  const handlePrev = () => sliderRef?.current?.prev();

  const handleNext = () => sliderRef?.current?.next();
  const finalImages = imageData?.filter((image) =>
    Object.values(image)?.some((value) => value !== null)
  );

  return (
    <div>
      <NextIcon className={styles.nextIcon} onClick={handleNext} />
      <PreviousIcon className={styles.previousIcon} onClick={handlePrev} />
      <Carousel ref={sliderRef} arrows infinite className={styles.carousel}>
        {finalImages?.map((item, i) => {
          const keyName = Object.keys(item)?.[0];

          return (
            <div
              className={styles.imageContainer}
              ref={visualizeSmallContainerRef}
              key={item[0]}
            >
              <div
                className={styles.imageWrapper}
                style={{ width: containerSmallWidthDynamic }}
              >
                <img
                  src={item[keyName]}
                  alt={keyName}
                  style={{ height: "100%", width: "100%" }}
                />
              </div>
              <div className={styles.imageName}>{keyName}</div>
              <div className={styles.frameNumber}>
                {positions?.[keyName] ?? "-"}
              </div>
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};
